var map = {
	"./Arabia.png": 2897,
	"./China.png": 3814,
	"./Egypt.png": 38538,
	"./Mayan_Empire.png": 34910,
	"./Viking_Kingdom.png": 11263,
	"./alhambra.png": 64603,
	"./brass.png": 21960,
	"./cdc.png": 32763,
	"./cheops.png": 23817,
	"./ci.png": 77263,
	"./col.png": 57873,
	"./cr.png": 748,
	"./de.png": 39582,
	"./forbidden.png": 44292,
	"./hg.png": 23832,
	"./hs.png": 26591,
	"./loa.png": 3823,
	"./petra.png": 65095,
	"./poa.png": 96227,
	"./sh.png": 75638,
	"./sherwood.png": 71776,
	"./simbel.png": 6397,
	"./sp.png": 9294,
	"./sphinx.png": 68445,
	"./terracotta.png": 91350,
	"./tikal.png": 39484,
	"./toa.png": 61607,
	"./tom.png": 38843,
	"./top.png": 66958,
	"./valhalla.png": 2930,
	"./wall.png": 98739,
	"./ygg.png": 64724,
	"./zeus.png": 74328
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45599;